import { render, staticRenderFns } from "./UserPhoneBindForm.vue?vue&type=template&id=f3f1d222&"
import script from "./UserPhoneBindForm.vue?vue&type=script&lang=js&"
export * from "./UserPhoneBindForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports